export function isEmail(str: null | string | undefined) {
  return str?.includes("@");
}

export function isPhone(str: null | string | undefined) {
  return !!str && /^\+\d+$/.test(str);
}

export const UNKNOWN_VALUE = "UNKNOWN";
